<form [formGroup]="paymentForm" (ngSubmit)="onSubmit(cardRef.cardType())" class="add-payment-form">
  <div class="add-payment-form__row">
    <label class="add-payment-form__label" for="card-number-input">
      {{
        'shop-settings.subscription.paymentMethod.addPaymentMethodModal.card-number-input'
          | translate
      }}
    </label>
    <div class="add-payment-form__card-type-wrapper">
      <input
        id="card-number-input"
        type="text"
        class="add-payment-form__input add-payment-form__input-card-type"
        placeholder="1234 1234 1234 1234"
        maxlength="19"
        formControlName="cardNumber"
        appPaymentCardNumberMask
        #cardRef="paymentCardType"
      />
      @switch (cardRef.cardType()) {
        @case ('visa') {
          <app-icon
            [icon]="iconName.PAYMENT_CARD_TYPE_VISA"
            class="add-payment-form__card-type-icon"
          />
        }
        @case ('mastercard') {
          <app-icon
            [icon]="iconName.PAYMENT_CARD_TYPE_MASTERCARD"
            class="add-payment-form__card-type-icon"
          />
        }
        @default {
          <app-icon
            [icon]="iconName.PAYMENT_CARD_TYPE_UNKNOWN"
            class="add-payment-form__card-type-icon"
          />
        }
      }
    </div>

    @if (getErrorMessage('cardNumber')) {
      <span class="error-text">{{ getErrorMessage('cardNumber') }}</span>
    }
  </div>
  <div class="add-payment-form__row">
    <label class="add-payment-form__label" for="card-holder-input">
      {{
        'shop-settings.subscription.paymentMethod.addPaymentMethodModal.card-holder-input'
          | translate
      }}
    </label>
    <input
      id="card-holder-input"
      class="add-payment-form__input"
      type="text"
      placeholder="Enter name on card"
      formControlName="cardHolder"
    />
    @if (getErrorMessage('cardHolder')) {
      <span class="error-text">{{ getErrorMessage('cardHolder') }}</span>
    }
  </div>
  <div class="add-payment-form__row add-payment-form__row--double">
    <div class="add-payment-form__row">
      <label class="add-payment-form__label" for="card-date-input">
        {{
          'shop-settings.subscription.paymentMethod.addPaymentMethodModal.exp-date-input'
            | translate
        }}
      </label>
      <input
        id="card-date-input"
        class="add-payment-form__input"
        type="text"
        placeholder="MM/YY"
        formControlName="expireDate"
        maxlength="5"
        appDateMaskDirective
      />
      @if (getErrorMessage('expireDate')) {
        <span class="error-text">{{ getErrorMessage('expireDate') }}</span>
      }
    </div>
    <div class="add-payment-form__row">
      <label class="add-payment-form__label" for="card-cvv-input">
        {{ 'shop-settings.subscription.paymentMethod.addPaymentMethodModal.cvv-input' | translate }}
      </label>
      <div class="add-payment-form__hint-wrapper">
        <input
          id="card-cvv-input"
          class="add-payment-form__input add-payment-form__input--with-icon"
          type="text"
          placeholder="CVV"
          formControlName="ccvData"
          maxlength="3"
          appDigitOnly
        />

        <app-icon
          #hintTrigger="matMenuTrigger"
          [matMenuTriggerFor]="cvcMenu"
          [icon]="iconName.CVV_HINT_CARD"
          class="add-payment-form__cvc-icon"
        />

        <mat-menu
          [class]="'cvv-custom-offset'"
          #cvcMenu="matMenu"
          [xPosition]="hintMenuConfig.x"
          [yPosition]="hintMenuConfig.y"
          [overlapTrigger]="hintMenuConfig.overlap"
          [hasBackdrop]="hintMenuConfig.backdrop"
        >
          <app-cvv-hint-component />
        </mat-menu>
      </div>
      @if (getErrorMessage('ccvData')) {
        <span class="error-text">{{ getErrorMessage('ccvData') }}</span>
      }
    </div>
  </div>
  <div class="add-payment-form__actions">
    <button
      type="button"
      class="add-payment-form__btn add-payment-form__btn--secondary"
      (click)="onCancel()"
    >
      {{ 'shop-settings.subscription.paymentMethod.addPaymentMethodModal.cancel-btn' | translate }}
    </button>

    <button
      type="submit"
      class="add-payment-form__btn add-payment-form__btn--primary"
      [disabled]="isSubmitting()"
    >
      {{ 'shop-settings.subscription.paymentMethod.addPaymentMethodModal.add-btn' | translate }}
    </button>
  </div>
</form>
